const sendToDataLayer = (eventName, eventParams) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    })
  }
}
const sendToDataLayerATM = (eventName, eventParams) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'atm.event',
      event_name: eventName,
      ...eventParams,
    })
  }
}

export const GTMEvents = {
  BtnMenuSubmenu: (opcion_menu, subopcion) => {
    sendToDataLayer('menu_click', {
      id: 'MOD-MEPA-HOME-BTN-OPTION-MENU',
      option: `${opcion_menu} - ${subopcion}`,
      location: 'home',
    })
  },

  BtnMenuAccess: name_botton => {
    sendToDataLayer('menu_button', {
      id: 'MOD-MEPA-HOME-BTN-MENU-ACCESS',
      option: `${name_botton}`,
      location: 'home',
    })
  },

  BtnHomeSliderHero: (slider_name, name_botton, position_botton) => {
    sendToDataLayer('slider_click', {
      id: 'MOD-MEPA-HOME-BTN-SLIDER-HERO',
      slider_name: `${slider_name}`,
      option: `${name_botton}`,
      position: `${position_botton}`,
      location: 'home',
    })
  },

  BtnHomeSliderColumnVerMas: (section, description, option) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-HOME-BTN-SLIDER-COLUMN',
      section: section,
      description: description,
      option: option,
      location: 'home',
    })
  },

  BtnCalculatePension: (gender, state) => {
    sendToDataLayer('interaction_form', {
      id: 'MOD-MEPA-HOME-BTN-CALCULATE-PENSION-FORM',
      section: 'Calcula tu pensión ideal',
      gender: gender,
      state: state,
      option: 'Calcular pensión',
      location: 'home',
    })
  },

  BtnProductsHome: () => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-HOME-BTN-PRODUCS-ITEM-FORM',
      section: 'Estos son los productos que tenemos para tí',
      description: 'Cuenta metas',
      option: 'Crear mi meta',
      location: 'home',
    })
  },

  FooterOption: (opcion_footer, opcion) => {
    sendToDataLayer('footer_click', {
      id: 'MOD-MEPA-HOME-FOOTER-ITEM',
      option: `${opcion_footer} - ${opcion}`,
      location: 'home',
    })
  },

  FooterOptionSocial: opcion => {
    sendToDataLayer('footer_click', {
      id: 'MOD-MEPA-HOME-FOOTER-SOCIAL-ITEM',
      option: `${opcion}`,
      location: 'home',
    })
  },

  HeaderBtnContact: opcion => {
    sendToDataLayer('link_click', {
      id: 'MOD-MEPA-HOME-HEADER-CONTACT',
      section: 'header',
      option: `${opcion}`,
      location: 'home',
    })
  },

  ChatBotBtnAccess: opcion => {
    sendToDataLayer('chatbot_click', {
      id: 'MOD-MEPA-HOME-CHAT-BOT',
      action: opcion,
      location: 'home',
    })
  },

  ContributionsAndFundBtn: (section, option) => {
    sendToDataLayer('banner_click', {
      id: 'MOD-MEPA-CONTRIBUTIONS-SECTION-BTN',
      section: section,
      option: option,
      location: 'Aportes y fondo',
    })
  },

  LinkSurvivalInsuranceHere: (section, option) => {
    sendToDataLayer('link_click', {
      id: 'MOD-MEPA-SURVIVAL-INSURANCE-LINK',
      section: section,
      option: option,
      location: 'Seguro sobrevivencia',
    })
  },

  ComercialAlliesRegisterBtn: (section, option) => {
    sendToDataLayer('banner_click', {
      id: 'MOD-MEPA-COMERCIAL-ALLIES-BTN-REGISTER',
      section: section,
      option: option,
      location: 'Aliados comerciales',
    })
  },

  ComercialAlliesFormBtn: (section, option) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-COMERCIAL-ALLIES-FORM-REGISTER',
      section: section,
      option: option,
      location: 'Aliados comerciales',
    })
  },

  ComercialAlliesListShop: (section, option) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-COMERCIAL-ALLIES-SHOP-ITEM',
      section: section,
      option: option,
      location: 'Aliados comerciales',
    })
  },

  AccountMetasBannerBtn: (slider_name, option) => {
    sendToDataLayer('banner_click', {
      id: 'MOD-MEPA-ACCOUNT-META-BANNER-BTN',
      section: 'cuenta metas',
      slider_name: slider_name,
      option: option,
      location: '/public-zone/productos/cuenta-metas',
    })
  },

  AccountMetasSectionBtn: (sub_section, option) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-ACCOUNT-META-SECTION-BTN',
      section: 'cuenta metas',
      sub_section: sub_section,
      option: option,
      location: '/public-zone/productos/cuenta-metas',
    })
  },

  AccountMetasFAQBtn: (sub_section, option) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-ACCOUNT-META-FAQ-BTN',
      section: 'cuenta metas',
      sub_section: sub_section,
      option: option,
      location: '/public-zone/productos/cuenta-metas',
    })
  },

  AccountMetasBenefitsCard: (sub_section, option) => {
    sendToDataLayer('card_click', {
      id: 'MOD-MEPA-ACCOUNT-META-BENEFITS-CARD',
      section: 'cuenta metas',
      sub_section: sub_section,
      option: option,
      location: '/public-zone/productos/cuenta-metas',
    })
  },

  AccountMetasInvestmentSection: (sub_section, option) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-ACCOUNT-META-INVESTMENT-SECTION',
      section: 'cuenta metas',
      sub_section: sub_section,
      option: option,
      location: '/public-zone/productos/cuenta-metas',
    })
  },

  AccountMetasInvestmentTestResult: (sub_section, option) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-ACCOUNT-META-INVESTMENT-RESULT',
      section: 'cuenta metas',
      sub_section: sub_section,
      option: option,
      location: '/public-zone/productos/cuenta-metas',
    })
  },

  HelpBookForm: (client_type, state, option, produc_type) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-ACCOUNT-META-HELP-BOOK-FORM',
      section: 'Libro de reclamaciones',
      product_name: produc_type,
      option: option,
      state: state,
      client_type: client_type,
    })
  },

  //tipos de aporte

  TypeContributionBreadcrumb: (section, sub_section, option, location) => {
    sendToDataLayer('breadcrum_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-BREADCRUMB',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionTabs: (section, sub_section, option, location) => {
    sendToDataLayer('tab_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-TAB-ITEM',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionQuestionsYape: (section, sub_section, option, location) => {
    sendToDataLayerATM('desplegable_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-QUEST',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionCuentaMetas: (section, sub_section, option, location) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-ACCOUNT-METAS',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionCuentaMetasBtnDocument: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-ACCOUNT-METAS-DOCUMENT',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  //tipos de fondo

  FundTypeScrollTestBtn: (sub_section, location) => {
    sendToDataLayer('scroll_click', {
      id: 'MOD-MEPA-TYPE-FUND-SCROLL-TEST',
      section: 'tipos de fondo',
      sub_section: sub_section,
      option: 'scroll',
      location: location,
    })
  },

  FundChangeTypeSectionBtn: (section, sub_section, option, location) => {
    sendToDataLayer('button_click', {
      id: 'MOD-MEPA-TYPE-FUND-CHANGE-BUTTON',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  FundTypeLinkSection: (section, sub_section, option, location) => {
    sendToDataLayer('link_click', {
      id: 'MOD-MEPA-TYPE-FUND-CHANGE-LINK',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  FundTypeResultTabInternLink: (section, sub_section, option, location) => {
    sendToDataLayer('link_click', {
      id: 'MOD-MEPA-TYPE-FUND-TAB-LINK-INTERN',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  FundTypeResultSbsLink: (section, sub_section, option, location) => {
    sendToDataLayer('link_click', {
      id: 'MOD-MEPA-TYPE-FUND-RESULT-LINK',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },
  //separate sendToDataLayer to sendToDataLayerATM
  //comisiones

  /**
       * 
       * @param {*} section 
       * @param {*} sub_section 
       * @param {*} option 
       * @param {*} location 
       * 
       *type='trabajadores pesqueros'
        GTMSection='Soy empleador Trabajadores Pesqueros'
        GTMTitle='Información para trabajadores pesqueros'
        GTMLink='/public-zone/trabajadores-pesqueros/' 
       */

  TypeContributionBreadcrumbATM: (section, sub_section, option, location) => {
    sendToDataLayerATM('breadcrum_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-BREADCRUMB-ATM',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  FundandChargesQuestionsCardsATM: (section, sub_section, option, location) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-MEPA-FUND-CHARGES-QUESTION-CARDS-ATM',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TransferenForengierCardsATM: (section, sub_section, option, location) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-MEPA-TRANSFERENT-EXTERIOR-CARDS-ATM',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TransferenForengierCartillaATM: (section, sub_section, option, location) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-MEPA-TRANSFERENT-EXTERIOR-CARDS-ATM',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionBtnDownload: (section, sub_section, option, location) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-BTN-DOWNLOAD',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },
  TypeContributionLinkType: (section, sub_section, option, location) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-LINK-TYPE',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },
  RetirementTabBtn: (event_name, section, sub_section, option, location) => {
    sendToDataLayerATM(event_name, {
      id: 'MOD-MEPA-RETIREMENT-TAB-BTN',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionAccordion: (section, sub_section, option, location) => {
    sendToDataLayerATM('desplegable_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-ACCORDION',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionAccordionLink: (section, sub_section, option, location) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-ACCORDION-LINK',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeContributionCardLink: (section, sub_section, option, location) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-CARD-LINK',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  TypeCardRetirementSection: (section, sub_section, option, location) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-RETIREMENT-SECTION',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  ButtonTabRetirement25: (section, sub_section, option, location) => {
    sendToDataLayerATM('tab_click', {
      id: 'MOD-BUTTON-TAB-RETIREMENT',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  // #region Jubilaci�n y Pensi�n
  ButtonJubilaPesion: (section, sub_section, option, location) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-BUTTON-JUB-PEN-BTN',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  ButtonJubilaPesionSection: (section, sub_section, option, location) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-BUTTON-JUB-PEN-SECTION-BTN',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },
  CardJubilaPesionSection: (section, sub_section, option, location) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-SECTION',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },
  CardModalidadJubilaPesionSection: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-SECTION-MODALIDAD',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },
  LinkModalidadJubilaPesionSection: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-LINK-JUB-PEN-SECTION-MODALIDAD-LINK',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  LinkPorcentajesPredeterminadosJubilaPension: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-LINK-JUB-PEN-PORCEN-PRED',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  CardFormatosRequisitosTramitesJubilaPension: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-FORMATOS-REQUI-TRAMI',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  ButtonIniciarMiTramiteRequiTramiJubilaPension: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-BUTTON-JUB-PEN-INICIAR-TRAMI-REQUI-TRAMI',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  // #region Aportes y Fondo (uso-del-25-de-mi-fondo-para-un-inmueble)
  LinkMiEspacioPrimaAporFondUso25MiFondoParaInmu: (
    section,
    name_tab,
    number_step,
    option,
    location
  ) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-LINK-APOR-FOND-USO-25-MI-FOND-PA-INMU',
      section: section,
      sub_section: `${name_tab} - ${number_step}`,
      option: option,
      location: location,
    })
  },

  BtnContributionActionBtn: (section, sub_section, option, location) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-MEPA-CONTRIBUTIONS-BTN-ACTION',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  // #region Acerca de AFP Net
  ButtonAcercaAfpNetIrAfpNet: (section, sub_section, option, location) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-BUTTON-ACERCA-AFP-NET-IR-AFP-NET',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  LinkAcercaAfpNetInfoAfpNet: (section, sub_section, option, location) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-LINK-ACERCA-AFP-NET-INFO-AFP-NET',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  // #region Formularios para trámites
  CardFormatoSolicitarDevolucionAportesAfpFormuTrami: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-FORMU-TRAMI-FORMATOS-SOLI-DEVOLU-APORT',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  // #region Trabajadores pesqueros
  CardFormatosAfiliarTrabajadoresPesqueros: (
    section,
    sub_section,
    option,
    location
  ) => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-TRABAJA-PESQUE-FORMATOS-AFILIAR',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  LinkCorreoTrabajadoresPesqueros: (section, sub_section, option, location) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-LINK-TRABAJA-PESQUE-CORREO',
      section: section,
      sub_section: sub_section,
      option: option,
      location: location,
    })
  },

  // #region AhorroYa
  AhorroValidationTokenError: (option, step) => {
    sendToDataLayerATM('type_error', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      step: String(step),
      option: String(option),
      location: 'AhorroYa!',
    })
  },
  AhorroYaStep1Btn: option => {
    sendToDataLayerATM('button_click', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      step: 'paso 1',
      option: String(option),
      location: 'AhorroYa!',
    })
  },
  AhorroYaStep2Btn: option => {
    sendToDataLayerATM('button_click', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      step: 'otp',
      option: String(option),
      location: 'AhorroYa!',
    })
  },
  AhorroYaIsAfilliateMessage: () => {
    sendToDataLayerATM('mensaje', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      option: 'Ya eres parte de ahorro ya!',
      location: 'AhorroYa!',
    })
  },
  AhorroYaIsAfilliateMessageFinishStage: () => {
    sendToDataLayerATM('finish_stage', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      option: 'Ya eres parte de ahorro ya!',
      location: 'AhorroYa!',
    })
  },
  AhorroYaIsNoAfilliateMessage: () => {
    sendToDataLayerATM('mensaje', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      option: 'Parece que no eres afiliado PRIMA AFP',
      location: 'AhorroYa!',
    })
  },
  AhorroYaBannerBtn: option => {
    sendToDataLayerATM('banner_click', {
      id: 'MOD-MEPA-COMERCIAL-ALLIES-BTN-REGISTER',
      section: 'Ahorro ya!',
      sub_section: 'Banner',
      option: String(option),
      location: 'AhorroYa!',
    })
  },

  AhorroYaBreadcrumBtn: option => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-BREADCRUMB-ATM',
      section: 'Ahorro ya!',
      sub_section: 'Breadcrum',
      option: String(option),
      location: 'AhorroYa!',
    })
  },

  AhorroYaBannerBtn: () => {
    sendToDataLayerATM('banner_click', {
      id: 'MOD-MEPA-COMERCIAL-ALLIES-BTN-REGISTER',
      section: 'Ahorro ya!',
      sub_section: 'Banner',
      option: 'Registrate al programa',
      location: 'AhorroYa!',
    })
  },

  AhorroYaBreadcrumBtn: option => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-MEPA-TYPE-CONTRIBUTION-BREADCRUMB-ATM',
      section: 'Ahorro ya!',
      sub_section: 'Breadcrum',
      option: String(option),
      location: 'AhorroYa!',
    })
  },

  AhorroYaSectionBtn: option => {
    sendToDataLayerATM('card_click', {
      section: 'Ahorro ya!',
      sub_section: 'Cards',
      option: String(option),
      location: 'AhorroYa!',
    })
  },

  AhorroYaActivateBtn: () => {
    sendToDataLayerATM('button_click', {
      section: 'Ahorro ya!',
      sub_section: 'Ya eres parte de ahorro ya!',
      option: 'Activar tu cuenta',
      location: 'AhorroYa!',
    })
  },

  AhorroYaUnidentifiedBtn: () => {
    sendToDataLayerATM('button_click', {
      section: 'Ahorro ya!',
      sub_section: 'No hemos podido indentificarte como nuestro cliente',
      option: 'Intentar con otro documento',
      location: 'AhorroYa!',
    })
  },

  AhorroYaErrorBtn: option => {
    sendToDataLayerATM('error', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      option: String(option),
      location: 'AhorroYa!',
    })
  },

  AhorroYaTermAndConditionBtn: option => {
    sendToDataLayerATM('checkbox_click', {
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      option: String(option),
      location: 'AhorroYa!',
    })
  },

  AhorroYaRegisterBtn: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-MEPA-COMERCIAL-ALLIES-FORM-REGISTER',
      section: 'Ahorro ya!',
      sub_section: 'Registrate al programa en menos de 1 minuto',
      step: 'otp validar codigo',
      option: 'validar codigo',
      location: 'AhorroYa!',
    })
  },

  AhorroYaStepBtn: option => {
    sendToDataLayerATM('button_click', {
      section: 'Ahorro ya!',
      sub_section: '¿Cómo hacer uso del programa?',
      option: String(option),
      location: 'AhorroYa!',
    })
  },

  AhorroYaBenefitsBtn: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-MEPA-COMERCIAL-ALLIES-SHOP-ITEM',
      section: 'Ahorro ya!',
      sub_section:
        'Ingresa a ahorroya.pe y descubre los beneficios que tenemos para ti',
      option: 'Conócelos aquí',
      location: 'AhorroYa!',
    })
  },

  AhorroYaQuestionBtn: option => {
    sendToDataLayerATM('button_click', {
      section: 'Ahorro ya!',
      sub_section: 'Preguntas frecuentes',
      option: String(option),
      location: 'AhorroYa!',
    })
  },
  // #region Jubilación y Pensión
  ModalidadesDePensionCardLink: sub_section => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-LINK-JUB-PEN-MOD-PEN',
      section: 'modalidades de pension',
      sub_section: sub_section,
      option: 'pensión de sobrevivencia',
      location: '/jubilacion-y-pension/modalidades-de-pension/',
    })
  },
  InformacionParaPensionistasCardClick: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-INF-PEN',
      section: 'soy pensionista',
      sub_section: 'Documentos informativos y formatos',
      option: option,
      location: '/jubilacion-y-pension/informacion-para-pensionistas/',
    })
  },
  CoberturaDelSeguroCardClick: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-COB-SEG',
      section: 'cobertura del seguro',
      sub_section: 'Conoce más sobre la Cobertura de seguro',
      option: option,
      location: '/jubilacion-y-pension/cobertura-del-seguro/',
    })
  },
  CoberturaDelSeguroTrabajadoresCardClick: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-COB-SEG-TRAB',
      section: 'cobertura del seguro',
      sub_section: 'Cobertura del seguro para trabajadores',
      option: option,
      location: '/jubilacion-y-pension/cobertura-del-seguro/',
    })
  },
  BonoDeReconocimientoCardClick: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-BON-REC',
      section: 'bono de reconocimiento',
      sub_section: 'Bono de Reconocimiento',
      option: option,
      location: '/jubilacion-y-pension/bono-de-reconocimiento/',
    })
  },
  BonoDeReconocimientoLinkClick: (sub_section, option) => {
    sendToDataLayerATM('link_click', {
      id: 'MOD-LINK-JUB-PEN-BON-REC',
      section: 'bono de reconocimiento',
      sub_section: sub_section,
      option: option,
      location: '/jubilacion-y-pension/bono-de-reconocimiento/',
    })
  },
  FallecimientoBtnClick: () => {
    sendToDataLayerATM('banner_click', {
      id: 'MOD-BTN-JUB-PEN-FALL',
      section: 'pension por fallecimiento',
      sub_section: 'pension por fallecimiento',
      option: 'Iniciar mi trámite',
      location: '/jubilacion-y-pension/fallecimiento/',
    })
  },
  FallecimientoTabClick: option => {
    sendToDataLayerATM('tab_click', {
      id: 'MOD-TAB-JUB-PEN-FALL',
      section: 'pension por fallecimiento',
      sub_section: 'pension por fallecimiento',
      option: option,
      location: '/jubilacion-y-pension/fallecimiento/',
    })
  },
  FallecimientoCardClick: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-FALL',
      section: 'pension por fallecimiento',
      sub_section: '¿Qué es la Pensión por fallecimiento?',
      option: option,
      location: '/jubilacion-y-pension/fallecimiento/pension-por-fallecimiento',
    })
  },
  JubilcionPensionBtnClick: (subsection, option) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-BTN-JUB-PEN',
      section: 'tipos de jubilacion y pension',
      sub_section: subsection,
      option: option,
      location: '/jubilacion-y-pension/',
    })
  },
  JubilcionPensionCardClick: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN',
      section: 'tipos de jubilacion y pension',
      sub_section: 'Entérate más sobre la jubilación y pensión',
      option: option,
      location: '/jubilacion-y-pension/',
    })
  },
  JubilcionPensionCardClick: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN',
      section: 'tipos de jubilacion y pension',
      sub_section: 'Entérate más sobre la jubilación y pensión',
      option: option,
      location: '/jubilacion-y-pension/',
    })
  },
  ModalidadesDePensionMenuCardLink: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-CARD-JUB-PEN-MOD-PEN',
      section: 'modalidades de pension',
      sub_section: 'Te enseñamos cuatro diferentes modalidades de pension',
      option: option,
      location: '/jubilacion-y-pension/modalidades-de-pension/',
    })
  },

  // #region Main Slider
  MainSlierView: (name, position) => {
    sendToDataLayerATM('slider_view', {
      id: 'MOD-VIEW-SLIDER-HERO',
      slider_name: name,
      position: position,
    })
  },

  // Cámbiate a Prima AFP (/por-que-elegir-prima/)
  PorqueElegirPrima_MainSliderButton: (sub_section, option) => {
    sendToDataLayerATM('banner_click', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-MAIN-SLIDER-BUTTON',
      section: 'campaña futuro inmediato',
      sub_section: sub_section,
      option: option,
      location: 'por-que-elegir-prima',
    })
  },

  PorqueElegirPrima_MainSliderView: sub_section => {
    sendToDataLayerATM('slider_view', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-MAIN-SLIDER-VIEW',
      section: 'campaña futuro inmediato',
      sub_section: sub_section,
      location: 'por-que-elegir-prima',
    })
  },

  PorqueElegirPrima_InfoCards: option => {
    sendToDataLayerATM('card_click', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-INFO-CARDS',
      section: 'campaña futuro inmediato',
      sub_section: 'en prima afp lo mas importante del futuro, es el hoy',
      option: option, // hasta 25% para tu primera vivienda - protege a tu familia - aporta rapidamente - beneficios prima - ahorra en combustible
      location: 'por-que-elegir-prima',
    })
  },

  PorqueElegirPrima_StartYourProcedure: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-START-YOUR-PROCEDURE',
      section: 'campaña futuro inmediato',
      sub_section: 'que tu propia casa sea una realidad',
      option: 'inicia tu tramite',
      location: 'por-que-elegir-prima',
    })
  },

  PorqueElegirPrima_LearnMore: option => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-LEARN-MORE',
      section: 'campaña futuro inmediato',
      sub_section: 'protege a tu familia',
      option: option, // cobertura de pension - cobertura de gastos - cobertura de la pension
      location: 'por-que-elegir-prima',
    })
  },

  PorqueElegirPrima_LearnHowContributeToYape: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-LEARN-HOW-CONTRIBUTE-TO-YAPE',
      section: 'campaña futuro inmediato',
      sub_section: 'yapeate y cuida tu futuro',
      option: 'conoce como aportar en yape',
      location: 'por-que-elegir-prima',
    })
  },

  PorqueElegirPrima_ExploreTheBenefits: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-EXPLORE-THE-BENEFITS',
      section: 'campaña futuro inmediato',
      sub_section: 'descuentos exclusivos',
      option: 'explora los beneficios',
      location: 'por-que-elegir-prima',
    })
  },

  PorqueElegirPrima_AffiliateNow: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PORQUE-ELEGIR-PRIMA-AFFILIATE-NOW',
      section: 'campaña futuro inmediato',
      sub_section: 'ahorra consumiendo',
      option: 'afiliate ahora',
      location: 'por-que-elegir-prima',
    })
  },

  // Conoce nuestra cultura Prima (/cultura-prima-afp/)
  CulturaPrimaAfp_WatchVideoButton: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-CULTURA-PRIMA-AFP-WATCH-VIDEO-BUTTON',
      section: 'cultura prima',
      sub_section: 'nuestro proposito',
      option: 'ver video',
      location: 'cultura-prima-afp',
    })
  },

  // Prima AFP Exclusive (/prima-afp-exclusive/)
  PrimaAfpExclusive_ClickButtonsHeader: (option) => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PRIMA-AFP-EXCLUSIVE-CLICK-BUTTONS-HEADER',
      section: 'exclusive prima',
      sub_section: 'header',
      option: option, // logo / atencion-personalizada / rentabilidad / beneficios
      location: 'prima-afp-exclusive',
    })
  },

  PrimaAfpExclusive_ClickButtonDownload: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PRIMA-AFP-EXCLUSIVE-CLICK-BUTTON-DOWNLOAD',
      section: 'exclusive prima',
      sub_section: 'reporte de inversiones',
      option: 'descargar',
      location: 'prima-afp-exclusive',
    })
  },

  PrimaAfpExclusive_ClickButtonRedirect: () => {
    sendToDataLayerATM('button_click', {
      id: 'MOD-PRIMA-AFP-EXCLUSIVE-CLICK-BUTTON-REDIRECT',
      section: 'exclusive prima',
      sub_section: 'beneficios prima',
      option: 'conoce tus beneficios',
      location: 'prima-afp-exclusive',
    })
  },
}
